module.exports = __webpack_public_path__ + "img/device_cover_c.1f023564.png";